import { LoaderFunctionArgs } from 'react-router-dom'
import { getWarranty } from '../../action'

export const warrantyDetailPageLoader = async (args: LoaderFunctionArgs) => {
    await getWarranty(parseInt(args.params.id as string))

    return null
}
